import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function Calendar({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66667 1.6665C7.1269 1.6665 7.5 2.0396 7.5 2.49984V3.33317H12.5V2.49984C12.5 2.0396 12.8731 1.6665 13.3333 1.6665C13.7936 1.6665 14.1667 2.0396 14.1667 2.49984V3.33317H15C16.3807 3.33317 17.5 4.45246 17.5 5.83317V6.6665H2.5V5.83317C2.5 4.45246 3.61929 3.33317 5 3.33317H5.83333V2.49984C5.83333 2.0396 6.20643 1.6665 6.66667 1.6665Z"
        fill={COLORS[color]}
      />
      <path
        d="M2.5 8.33317V15.8332C2.5 17.2139 3.61929 18.3332 5 18.3332H15C16.3807 18.3332 17.5 17.2139 17.5 15.8332V8.33317H2.5Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
